<template>
  <div>
    <div class="footer__wrapper" id="contact">
      <div class="footer__content">
        <h1 class="light alignCenter">Ota yhteyttä</h1>
        <div class="form__wrapper ">
          <p data-v-66475aa5="" class="light alignCenter">
            Keikkakyselyt ja muut kysymykset tätä kautta. Rohkeasti vaan! Lue
            myös <a href="#" v-scroll-to="'#faq'">usein kysytyt kysymykset</a>.
          </p>
          <form
            action="https://formspree.io/f/amiraaliahtio@gmail.com"
            method="POST"
          >
            <input type="name" name="name" placeholder="Nimesi" />
            <input
              class="marginTop--small"
              type="email"
              name="email"
              placeholder="Sähköpostiosoitteesi"
              required
            />
            <input
              class="marginTop--small"
              type="phone"
              name="phone"
              placeholder="Puhelinnumerosi (valinnainen)"
            />
            <textarea
              rows="5"
              class="marginTop--small"
              name="message"
              placeholder="Viestisi"
            ></textarea>
            <p class="light alignCenter">
              Vastaamme jokaiseen yhteydenottoon; <br />
              jos et kuule meistä muutamaan päivään, tarkistathan sähköpostisi
              roska- ja mainoslaatikon.
            </p>
            <div class="marginTop--medium">
              <button type="submit">Lähetä</button>
            </div>
          </form>
          <p class="light alignCenter marginTop--medium">
            ps. Meidät tavoittaa myös
            <a href="https://www.instagram.com/amiraaliahtio/" target="_blank">
              Instagramista</a
            >
            ja
            <a href="https://www.facebook.com/amiraaliahtio/" target="_blank"
              >Facebookista</a
            >.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1:first-child {
  margin: 0;
}

.footer__wrapper {
  background-color: black;
  display: flex;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  padding: 0 0 4rem 0;
}
.footer__content {
  width: 75%;
  padding: 2rem;
}

.form__wrapper {
  max-width: 50%;
  margin: auto;
}

input {
  width: 100%;
  padding: 1rem;
  font-size: 1rem;
  border: none;
  border-radius: 10px;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}
textarea {
  width: 100%;
  padding: 1rem;
  font-size: 1rem;
  resize: none;
  border: none;
  border-radius: 10px;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}

textarea:focus,
input:focus {
  outline: none;
}

@media (max-width: 900px) {
  .footer__content {
    width: 100%;
  }

  .form__wrapper {
    max-width: 75%;
    margin: auto;
  }
}
@media (max-width: 700px) {
  .form__wrapper {
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ContactForm.vue